import React, { useState, useEffect } from 'react';
import { Scissors, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { name: 'About', id: 'about' },
    { name: 'Services', id: 'services' },
    { name: 'Branches', id: 'branches' },
    { name: 'Gallery', id: 'gallery' },
    { name: 'Reviews', id: 'reviews' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="relative">
              <div className="absolute inset-0 bg-[#C9A227]/20 blur-lg scale-110"></div>
              <img 
                src="/marks-barber-logo-transparent.png" 
                alt="Mark's Barber"
                className="relative h-14 w-14 object-contain"
                style={{
                  filter: 'drop-shadow(0 0 8px rgba(201, 162, 39, 0.5))'
                }}
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white font-playfair tracking-wider">MARK'S BARBER</h1>
              <p className="text-xs text-[#C9A227] tracking-widest">EST. 2017</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-white hover:text-[#C9A227] transition-colors duration-300 font-medium tracking-wide"
              >
                {item.name}
              </button>
            ))}
            <Button
              onClick={() => scrollToSection('branches')}
              className="bg-[#C9A227] hover:bg-[#B89220] text-black font-semibold transition-all duration-300 hover:scale-105"
            >
              Book Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-md border-t border-gray-800">
            <nav className="flex flex-col space-y-4 py-6 px-4">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-white hover:text-[#C9A227] transition-colors duration-300 font-medium text-left"
                >
                  {item.name}
                </button>
              ))}
              <Button
                onClick={() => scrollToSection('branches')}
                className="bg-[#C9A227] hover:bg-[#B89220] text-black font-semibold w-full"
              >
                Book Now
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;